import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import { ISchemaDetails } from '../../../../models/index';
import SchemaDetailsForm from './SchemaDetailsForm';
import classes from './SchemaDetailsForm.module.scss';

const SchemaDetails = ({ formData, handleInputChange, setFormParamValues, preview, isCheckClicked, isEditFormClicked, setSensitiveFieldsArr, sensitiveFieldsArr }: ISchemaDetails) => {
  const { t: translate } = useTranslation();

  return (
    <div className={`form-wrapper-container ${classes['main-container']}`}>
      <div>
        <Row className={classes['row-spacing']}>
          <Col sm={12} className={classes['col-spacing']}>
            <div className={classes['main-title']}> {translate('schema_details_form_components.title_schema_details')}</div>
            <div className={classes['sub-title']}>{translate('schema_details_form_components.sub_title_schema_details')}</div>
          </Col>
        </Row>
        <Row>
          <Col sm={8} md={7} lg={7} className={classes['col-spacing']}>
            <SchemaDetailsForm
              formData={formData}
              handleInputChange={handleInputChange}
              setFormParamValues={setFormParamValues}
              preview={preview}
              isCheckClicked={isCheckClicked}
              isEditFormClicked={isEditFormClicked}
              setSensitiveFieldsArr={setSensitiveFieldsArr}
              sensitiveFieldsArr={sensitiveFieldsArr}
            />
          </Col>
          <Col sm={4} md={5} lg={5}>
            <div className={classes['form-subtext']}>
              <ul>
                <li> {translate('schema_details_form_components.schema_form_subtext1')}</li>
                <li> {translate('schema_details_form_components.schema_form_subtext2')}.</li>
                <li>{translate('schema_details_form_components.schema_form_subtext3')}</li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SchemaDetails;
